module.exports = __webpack_public_path__ + "static/img/epidemic-6.fb679ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-6.png
// module id = dAqu
// module chunks = 1